module.exports = __webpack_public_path__ + "img/home_top_3.622f31b1.png";